/**
 * Status cascade rules for orders. Mirrors the backend whitelist in
 * server.py (`_STATUS_NEXT`). Forward-only; cancelled is reachable from
 * any non-terminal state; terminal states (delivered, cancelled) cannot
 * transition.
 */
export const STATUS_NEXT = {
  pending:    new Set(["confirmed", "cancelled"]),
  confirmed:  new Set(["on_the_way", "cancelled"]),
  on_the_way: new Set(["delivered", "cancelled"]),
  delivered:  new Set(),
  cancelled:  new Set(),
};

/**
 * Returns true if the admin is allowed to transition an order from
 * `current` to `next`. Same status is treated as a no-op (allowed).
 */
export function canTransition(current, next) {
  if (current === next) return true;
  return STATUS_NEXT[current]?.has(next) ?? false;
}

/**
 * Convenience: which single status comes next in the happy path
 * (excluding cancellation)? Returns null at terminal states.
 */
export function nextHappyStatus(current) {
  return ({
    pending: "confirmed",
    confirmed: "on_the_way",
    on_the_way: "delivered",
  })[current] || null;
}
